"use client";

import { useEffect } from 'react';

/**
 * FIX SC 2.4.2 [A]: Update document.title on every route change so every page
 * has a unique descriptive title for screen readers and search results.
 */
const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default usePageTitle;
